import { render, staticRenderFns } from "./Groupmedical.vue?vue&type=template&id=2dc931d3&scoped=true&"
import script from "./Groupmedical.vue?vue&type=script&lang=js&"
export * from "./Groupmedical.vue?vue&type=script&lang=js&"
import style0 from "./Groupmedical.vue?vue&type=style&index=0&id=2dc931d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc931d3",
  null
  
)

export default component.exports